import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The live count COA's own "Overdue" Overview fact shows: how many lots on H.Release have aged past this tenant's own
 * configured ageing window with no result, as the framework's `PortalFigure` (FLF-S88). The number opens the first
 * overdue lots in a drawer and links to Samples filtered to Overdue.
 *
 * Mounted as one of the manifest's own `overviewSection.facts`, on `CoaPendingReviewCountBadge`'s own exact precedent: its
 * own transport, its own query, the endpoint's `totalCount` as the value.
 * The read is the Samples endpoint filtered to `status:in:overdue` (FLF-S87), so the count and the full list agree.
 */
import { usePortalModuleLocation, usePortalModuleTransport } from '@equerranz/portal-module-contract';
import { PortalDateTime, PortalFigure, PortalListView, PortalStack, PortalText, } from '@equerranz/portal-ui';
import { useQuery } from '@tanstack/react-query';
import { COA_SLUG } from './acceptanceReferences.js';
import { overdueLotsQueryOptions } from './lotsOnHoldRelease.js';
/** How many rows the drawer shows before it points at the full list. */
const DRAWER_ROW_LIMIT = 10;
const OVERDUE_SAMPLES_PATH = 'lots-on-hold-release?filter=status:in:overdue';
const COLUMNS = [
    { columnId: 'itemNo', header: 'Item No', renderCell: (lot) => lot.itemNo },
    { columnId: 'lotNo', header: 'Lot No', renderCell: (lot) => lot.lotNo },
    {
        columnId: 'holdReleaseObservedAt',
        header: 'On hold since',
        renderCell: (lot) => _jsx(PortalDateTime, { value: lot.holdReleaseObservedAt }),
    },
];
export function CoaOverdueLotsCountBadge() {
    const transport = usePortalModuleTransport(COA_SLUG);
    const location = usePortalModuleLocation(COA_SLUG);
    const overdue = useQuery(overdueLotsQueryOptions(transport));
    const total = overdue.data === undefined ? 0 : Number(overdue.data.totalCount ?? overdue.data.lots.length);
    return (_jsx(PortalFigure, { label: "Overdue", value: overdue.isError ? 'Unavailable' : overdue.data === undefined ? undefined : total, drilldown: {
            title: 'Overdue lots',
            records: () => (_jsxs(PortalStack, { children: [_jsx(PortalListView, { ariaLabel: "Overdue lots", columns: COLUMNS, rows: overdue.data?.lots.slice(0, DRAWER_ROW_LIMIT) ?? [], getRowId: (lot) => lot.id, emptyMessage: "No lots are overdue." }), total > DRAWER_ROW_LIMIT ? (_jsxs(PortalText, { typeRole: "body", as: "p", children: ["Showing ", DRAWER_ROW_LIMIT, " of ", total] })) : null] })),
            fullListHref: location.hrefOf(OVERDUE_SAMPLES_PATH),
            // The href starts at the module root and `navigate` takes a path relative to it, so the href is not passed on.
            onNavigate: () => {
                location.navigate(OVERDUE_SAMPLES_PATH);
            },
        } }));
}
export default CoaOverdueLotsCountBadge;
//# sourceMappingURL=CoaOverdueLotsCountBadge.js.map